import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Map from 'components/svg/Map';
import './StaticMap.scss';

export function StaticMap({ className, children }) {

	return (
		<div className={classnames('static-map-wrapper', className)}>
			<div className="map-container">
				<Map />
				{children}
			</div>
		</div>
	);
}

StaticMap.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
};

export default StaticMap;
